// This file is no longer needed as we're using live Supabase data only
// Keeping empty component for backward compatibility

export function OfflineReadyIndicator() {
  return null;
}

export function OfflineSyncStatus() {
  return null;
}

export function FloatingOfflineStatus() {
  return null;
}
